'use client';

import { useLocale } from 'next-intl';
import { useEffect } from 'react';

const SmartBanner = () => {
  const locale = useLocale();

  useEffect(() => {
    // Dynamically import the SDK only on the client side
    import('@adjustcom/smart-banner-sdk').then((AdjustSmartBannerModule) => {
      const AdjustSmartBanner = AdjustSmartBannerModule.default || AdjustSmartBannerModule;

      AdjustSmartBanner.init({
        appToken: {
          ios: 'v87nmlq2r8jk',
          android: '9u1mtzubx91c',
        },
        language: locale,
      });
    });

    // Optional cleanup function
    return () => {
      // Add cleanup logic if the SDK provides a method for this
    };
  }, [locale]); // Add locale as a dependency since you're using it in the effect

  return null;
};

export default SmartBanner;
